export const MAX_NUMBER_OF_ARRANGEMENTS = 16;
export const MAX_NUMBER_OF_CHORDS = 16;
export const MAX_NUMBER_OF_SECTIONS = 16;

export const MAX_LOGIN_COOKIE_AGE_MS = 1000 * 60 * 60 * 24; // 24 Hours
